import { LanguageType } from "../../types";

export default function getFontFamily(language: LanguageType): string {
  const fontFamilyByLanguage: Record<LanguageType, string> = {
    "zh-HK": "'Noto Sans TC', sans-serif",
    "zh-TW": "'Noto Sans TC', sans-serif",
    ja: "'Noto Sans JP', sans-serif",
    ko: "'Noto Sans KR', sans-serif",
  };

  return fontFamilyByLanguage[language];
}
